{
  "el": {
    "announcement": {
      "actions": {
        "allUpdates": "Όλες οι ενημερώσεις",
        "delete_announcement": "Διαγραφή ανακοίνωσης",
        "edit": "Επεξεργασία",
        "new": "Ανακοίνωση",
        "pin": "Καρφίτσωμα στην κορυφή",
        "retry": "Δοκίμασε ξανά",
        "save": "Αποθήκευση",
        "submit": "Δημοσίευση",
        "unpin": "Ξεκαρφίτσωμα από την κορυφή"
      },
      "attributes": {
        "description": "Περιγραφή"
      },
      "labels": {
        "allUnits": "όλα τα ακίνητα",
        "archiveSubtitle": "Όλα όσα δημοσιεύσαμε για το {project}, με τα νεότερα πρώτα.",
        "customers": "πελάτες",
        "for": "για",
        "image_tab": "Εικόνα",
        "notSeenYet": "Δεν το έχει δει ακόμη",
        "now": "Τώρα",
        "pinned": "Αυτή η ανακοίνωση εμφανίζεται στην κορυφή της σελίδας του πελάτη.",
        "pinnedBadge": "Καρφιτσωμένη",
        "seen": "Το είδαν",
        "seenByCount": "Το είδαν {count} από {total}",
        "sharedWithPrefix": "Κοινοποιήθηκε σε",
        "sharedWithProject": "Κοινοποιήθηκε σε {units} του έργου {project}",
        "someUnits": "ορισμένα ακίνητα",
        "start": "Έναρξη",
        "unitsCount": "1 ακίνητο | {count} ακίνητα",
        "video_tab": "Βίντεο",
        "youtube_video": "URL βίντεο YouTube"
      },
      "name": "Ανακοίνωση",
      "placeholders": {
        "customers": {
          "failed": {
            "subtitle": "Έλεγξε τη σύνδεσή σου και δοκίμασε ξανά.",
            "title": "Δεν ήταν δυνατή η φόρτωση των ενημερώσεων"
          },
          "missing": {
            "title": "Αυτή η ενημέρωση δεν είναι πλέον διαθέσιμη"
          },
          "none": {
            "subtitle": "Σύντομα θα βρίσκεις τακτικές ενημερώσεις για το εργοτάξιο στην αρχική σου σελίδα.",
            "title": "Εδώ θα βρίσκεις τα νέα σου"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Καλωσόρισε τους πελάτες σου ή κοινοποίησε μια ενημέρωση για το έργο.",
            "title": "Δημιούργησε την πρώτη σου ανακοίνωση"
          },
          "none": {
            "project_required": "Επίλεξε ένα έργο",
            "selectProject": "Επίλεξε ένα έργο και ξεκίνα να δημιουργείς",
            "subtitle": "Καλωσόρισε τους πελάτες σου ή κοινοποίησε μια ενημέρωση για οποιοδήποτε έργο."
          },
          "paste_video_url": "Επικόλλησε εδώ τον σύνδεσμο YouTube"
        }
      },
      "toasts": {
        "create": "Η ανακοίνωση δημοσιεύτηκε",
        "delete": "Η ανακοίνωση διαγράφηκε",
        "invalid_video": "Αυτό δεν είναι έγκυρο βίντεο YouTube",
        "update": "Η ανακοίνωση ενημερώθηκε"
      },
      "validation": {
        "pleaseAddContent": "Πρόσθεσε εικόνα, βίντεο ή περιγραφή"
      }
    }
  }
}
